let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {
    // loadScript("//www.wearcomet.com/cdn/shop/t/253/assets/cart-drawer.js?v=68401610320305176801783066234");
    loadCSS("//www.wearcomet.com/cdn/shop/t/253/assets/component-cart.css?v=61086454150987525971783066234");

      document.querySelectorAll('.placeholder-slk-prnt')?.forEach(el => {
        el.style.opacity = '0';
      });

      document.querySelectorAll('.onrendered-slider-prnt')?.forEach(el => {
        el.style.opacity = '1';
      });
  
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}